import React from 'react'

// third party components

// images and icons
import ShareSmallIcon from 'assets/icons/share-black-menu.svg?component'
import SolanaFMIcon from 'assets/icons/solana-fm-icon-15x22.svg?component'

// styles
import styles from './index.module.scss'

interface ProfileMenuPageProps {
  setOpenShareModal: any
  copyWalletAddress: any
}

const ProfileMenuPage = ({ setOpenShareModal, copyWalletAddress }: ProfileMenuPageProps) => {
  return (
    <div className={styles.menuArea}>
      <div
        className={`${styles.menuItem}`}
        onClick={() => {
          setOpenShareModal(true)
        }}
      >
        <div className="flex gap-[15px] items-center">
          <div className={styles.itemIcon}>
            <ShareSmallIcon alt="" />
          </div>
          <div>
            <div className={styles.itemTitle}>Share Profile</div>
            <div className={styles.itemDescription}>Share to socials or copy link</div>
          </div>
        </div>
        <div className={styles.separator} />
      </div>

      <div
        className={`${styles.menuLastItem}`}
        onClick={() => {
          copyWalletAddress()
        }}
      >
        <div className="flex gap-[15px] items-center">
          <div className={styles.itemIcon}>
            <SolanaFMIcon alt="" />
          </div>
          <div>
            <div className={styles.itemTitle}>Copy Wallet Address</div>
            <div className={styles.itemDescription}>See transaction details and history</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileMenuPage
